import data from './data'
import components from './components'

export default {
  data,
  components,
  resourcePath: '/v1/policy'
}



// WEBPACK FOOTER //
// ./src/app/auth/terms/policy/resources/index.js